import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';

export const useSalaryIncompletePeriodSchema = ({ displaySalaryMinimumS6202, hasSalaryMinimumContratS6202, displayMaintien }) => {
    const { t } = useTranslation();
    const requiredMessage = t('yup.validators.required');

    return Yup.object().shape({
        interruptionActivityS6202: Yup.object({
            interruptions: Yup.array()
                .of(
                    Yup.object({
                        id: Yup.string(),

                        startDate: Yup.date()
                            .nullable()
                            .test('custom-validation-startDate', requiredMessage, function (value) {
                                const { parent, createError } = this;
                                const { date_echeance_paie, endDate, montant_brut, cotisationDeducted, reasonCod } = parent;
                                const hasValue = !!date_echeance_paie || !!endDate || !!montant_brut || !!cotisationDeducted || !!reasonCod;
                                if (hasValue && !value) return createError({ message: requiredMessage, path: this.path });
                                return true;
                            }),
                        endDate: Yup.date()
                            .nullable()
                            .test('custom-validation-endDate', requiredMessage, function (value) {
                                const { parent, createError } = this;
                                const { date_echeance_paie, startDate, montant_brut, cotisationDeducted, reasonCod } = parent;
                                const hasValue = !!date_echeance_paie || !!startDate || !!montant_brut || !!cotisationDeducted || !!reasonCod;
                                if (hasValue && !value) return createError({ message: requiredMessage, path: this.path });
                                return true;
                            }),
                        amount: Yup.string().nullable(),
                        // .test('custom-validation-montant_brut', requiredMessage, function (value) {
                        //     const { parent, createError } = this;
                        //     const { date_echeance_paie, startDate, endDate, cotisationDeducted, reasonCod } = parent;
                        //     const hasValue = !!date_echeance_paie || !!startDate || !!endDate || !!cotisationDeducted || !!reasonCod;
                        //     if (hasValue && !value) return createError({ message: requiredMessage, path: this.path });
                        //     return true;
                        // }),
                        cotisationDeducted: Yup.string().nullable(),
                        // .test('custom-validation-cotisationDeducted', requiredMessage, function (value) {
                        //     const { parent, createError } = this;
                        //     const { date_echeance_paie, startDate, endDate, montant_brut, reasonCod } = parent;
                        //     const hasValue = !!date_echeance_paie || !!startDate || !!endDate || !!montant_brut || !!reasonCod;
                        //     if (hasValue && !value) return createError({ message: requiredMessage, path: this.path });
                        //     return true;
                        // })
                        reasonCod: Yup.string()
                            .nullable()
                            .test('custom-validation-reasonCod', requiredMessage, function (value) {
                                const { parent, createError } = this;
                                const { date_echeance_paie, startDate, endDate, montant_brut, cotisationDeducted } = parent;
                                const hasValue = !!date_echeance_paie || !!startDate || !!endDate || !!montant_brut || !!cotisationDeducted;
                                if (hasValue && !value) return createError({ message: requiredMessage, path: this.path });
                                return true;
                            }),
                    }),
                )
                .optional(),
        }).required(),
        salaryMinimumS6202: Yup.object({
            amount: displaySalaryMinimumS6202 ? Yup.string().required() : Yup.string().nullable(),
            contract: hasSalaryMinimumContratS6202 ? Yup.string().required() : Yup.string().nullable(),
            contractDate: hasSalaryMinimumContratS6202 ? Yup.date().required() : Yup.date().nullable(),
        }).optional(),
        maintienInterruptionActivityS6202: displayMaintien ? Yup.string().required() : Yup.string().nullable(),
    });
};
